import * as types from "../types";
import * as _api from "../../api";
import { call, put, takeLatest } from "redux-saga/effects";
import { clearErrors, returnErrors } from "../actions/errorAction";
import { otpFailure, otpSuccess } from "../actions/otpAction";

function* asyncSubmitOtpRequestSaga(action){

    try{
    yield put(clearErrors());
    let otpResult = yield call(_api.submitOtpRequest,{
        otpReq: action.payload.otpReq
    })
     yield put(otpSuccess({otpResult}));
    }catch(e){
        yield put(otpFailure({error:e}));
        yield put(returnErrors({msg:e.message, status: true}))
    }

}

export default function* submitOtpRequestSaga(){
    yield takeLatest(types.OTP_REQUEST,asyncSubmitOtpRequestSaga)
}